/**
 * Do not edit directly
 * Generated on Wed, 17 Apr 2024 09:25:51 GMT
 */

export const SDS_COLOR_BLACK = "#000000"; // Color black.
export const SDS_COLOR_WHITE = "#ffffff"; // Color white.
